var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.92,
    height: 18.744,
    viewBox: "0 0 14.92 18.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(14.92 18.236) rotate(180)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M7.411,2.793a2,2,0,0,1,3.413,0l5.552,9.085a2,2,0,0,1-1.707,3.043H3.566A2,2,0,0,1,1.86,11.877Z",
    transform: "translate(0 18.236) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y2: 13.64,
    transform: "translate(2.239 1.492)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup40);
export default __webpack_public_path__ + "static/media/Group 40.447c5dc42ea9d4d48c58ee1211594242.svg";
export { ForwardRef as ReactComponent };